export default {
    appUrl: process.env.APP_URL || '',
    apiUrl: process.env.API_URL || '',
    seedUrl: process.env.SEED_URL || ''
};
